import request from '../../utils/request';

const getEnrollmentHistory = (payload) =>
  request({
    url: '/enrollment/history/findHistory',
    method: 'GET',
    params: payload,
  });

export default {
  getEnrollmentHistory,
};
